import React from 'react';
import { AuthPage } from './Login';

const Signup = () => {
  const handleSubmit = async (e) => {
    e.preventDefault();
    const userData = {
      email: e.target.email.value,
      password: e.target.password.value,
    };

    try {
      await signup(userData);
      
      // New users are guests by default, redirect to guest dashboard
      navigate('/guest');
    } catch (err) {
      console.error(err);
    }
  };

  return <AuthPage initialMode="signup" onSubmit={handleSubmit} />;
};

export default Signup;